import {
  StyledCountryOptionContent,
  StyledCountryTrigram,
  StyledNameContainer
} from './CountryOptionContent.style'

interface CountryOptionContentProps {
  countryCode: string
  countryName: string
}

export const CountryOptionContent = ({
  countryCode,
  countryName
}: CountryOptionContentProps) => {
  return (
    <StyledCountryOptionContent>
      <StyledCountryTrigram>{countryCode}</StyledCountryTrigram>
      <StyledNameContainer>{countryName}</StyledNameContainer>
    </StyledCountryOptionContent>
  )
}
